import React from 'react';
import PropTypes from 'prop-types';
import { ICON_CLASSES } from './Constants';
import styles from './Notifications.module.scss';
import { isEmpty } from '../../utils/helper';
const NotificationItem = props => {
  const {
    notification,
    redirectUrl,
    updateNotification
  } = props;
  const {
    userType,
    message,
    body,
    timeStamp,
    subject,
    tagName,
    idToReplace,
    isRead
  } = notification;
  const url = redirectUrl.replace('{itemId}', idToReplace);
  const userTypeTitle = !isEmpty(userType) ? userType.charAt(0).toUpperCase() + userType.replace(/_/g, ' ').slice(1) : '';
  const markAsRead = e => {
    e.preventDefault();
    updateNotification(notification);
  };
  const renderTitle = () => /*#__PURE__*/React.createElement("div", {
    className: styles.notifictionTitle
  }, ICON_CLASSES.get(userType) ? /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles.notificationIcon, " ").concat(ICON_CLASSES.get(userType)),
    title: userTypeTitle
  }) : /*#__PURE__*/React.createElement("span", {
    className: "icon-note",
    title: userTypeTitle
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.notificationSubject
  }, subject || idToReplace), tagName && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.notificationTag
  }, tagName)), /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: "0",
    className: "".concat(isRead ? 'icon-circle-check-active' : 'icon-circle-check-static', "  ").concat(styles.notificationUnread),
    onClick: markAsRead
  }));
  return /*#__PURE__*/React.createElement("a", {
    className: styles.notificationContent,
    href: url,
    target: "_blank",
    rel: "noopener"
  }, renderTitle(), /*#__PURE__*/React.createElement("div", {
    className: styles.notificationItem
  }, message && /*#__PURE__*/React.createElement("div", {
    className: styles.notificationMessage
  }, message), /*#__PURE__*/React.createElement("div", {
    className: styles.notificationTimeStamp
  }, timeStamp)), body && /*#__PURE__*/React.createElement("div", {
    className: styles.notificationbody,
    title: body
  }, body));
};
NotificationItem.propTypes = {
  notification: PropTypes.object,
  redirectUrl: PropTypes.string,
  updateNotification: PropTypes.func
};
NotificationItem.defaultProps = {
  notification: {},
  redirectUrl: '',
  updateNotification: () => {}
};
export default NotificationItem;